export enum SPT_FE_BE_MAPPING_FIELD {
    id = 'id',
    companyName = 'companyName',
    address = 'address',
    city = 'city',
    country = 'country',
    region = 'region',
    email = 'email',
    contactName = 'contactName',
    phone = 'phone',
    SAPID = 'SAPID',
    provideSAPID = 'provideSAPID',

}
export class SPT {
    id: number;
    address: string;
    city: string;
    country: string;
    companyName: string;
    region: string;
    email: string;
    contactName: string;
    phone: string;
    SAPID: string;
    provideSAPID: string;

    constructor(params: any = {}, parsed: boolean = true) {

        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.id = params.id;
            this.address = params.address;
            this.city = params.city;
            this.country = (params.country);
            this.companyName = params.companyName;
            this.region = params.region;
            this.email = params.email;
            this.contactName = params.contactName;
            this.phone = params.phone;
            this.SAPID = params.SAPID;
            this.provideSAPID = params.provideSAPID;
        }
    }

    parseFromResp(respObject: any = {}) {
        this.id = respObject[SPT_FE_BE_MAPPING_FIELD.id];
        this.address = respObject[SPT_FE_BE_MAPPING_FIELD.address];
        this.city = respObject[SPT_FE_BE_MAPPING_FIELD.city];
        this.country = respObject[SPT_FE_BE_MAPPING_FIELD.country];
        this.companyName = respObject[SPT_FE_BE_MAPPING_FIELD.companyName];
        this.region = respObject[SPT_FE_BE_MAPPING_FIELD.region];
        this.email = respObject[SPT_FE_BE_MAPPING_FIELD.email];
        this.contactName = respObject[SPT_FE_BE_MAPPING_FIELD.contactName];
        this.phone = respObject[SPT_FE_BE_MAPPING_FIELD.phone];
        this.SAPID = respObject[SPT_FE_BE_MAPPING_FIELD.SAPID] ? 'Yes' : 'No';
        this.provideSAPID = respObject[SPT_FE_BE_MAPPING_FIELD.provideSAPID];
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[SPT_FE_BE_MAPPING_FIELD.id] = this.id;
        body[SPT_FE_BE_MAPPING_FIELD.city] = this.city;
        body[SPT_FE_BE_MAPPING_FIELD.address] = this.address;
        body[SPT_FE_BE_MAPPING_FIELD.country] = this.country;
        body[SPT_FE_BE_MAPPING_FIELD.companyName] = this.companyName;
        body[SPT_FE_BE_MAPPING_FIELD.region] = this.region;
        body[SPT_FE_BE_MAPPING_FIELD.email] = this.email;
        body[SPT_FE_BE_MAPPING_FIELD.contactName] = this.contactName;
        body[SPT_FE_BE_MAPPING_FIELD.phone] = this.phone;
        body[SPT_FE_BE_MAPPING_FIELD.SAPID] = this.SAPID || 'No';
        body[SPT_FE_BE_MAPPING_FIELD.provideSAPID] = this.provideSAPID;
        return body;

    }
}
